var moduleMap = {
	"./prefetchAssets": () => {
		return Promise.all([__webpack_require__.e(860), __webpack_require__.e(476), __webpack_require__.e(450), __webpack_require__.e(426)]).then(() => (() => ((__webpack_require__(7426)))));
	},
	"./Asset": () => {
		return Promise.all([__webpack_require__.e(860), __webpack_require__.e(62), __webpack_require__.e(476), __webpack_require__.e(450), __webpack_require__.e(743), __webpack_require__.e(694)]).then(() => (() => ((__webpack_require__(9694)))));
	},
	"./InternalQuestion": () => {
		return Promise.all([__webpack_require__.e(860), __webpack_require__.e(62), __webpack_require__.e(450), __webpack_require__.e(743), __webpack_require__.e(706)]).then(() => (() => ((__webpack_require__(1814)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});